import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Legacy login URLs → canonical practice dashboard route */
const PracticeAdminLegacyRedirect = () => {
  const { practiceId } = useParams();
  return <Navigate to={`/practices/${practiceId}`} replace />;
};

export default PracticeAdminLegacyRedirect;
